import type { Permission } from './types'

export function permissionLabel(permission: Permission): string {
    return permission.description?.trim() || permission.code || `Permission #${permission.id}`
}

export function sortPermissions(permissions: Permission[]): Permission[] {
    return [...permissions].sort((a, b) => permissionLabel(a).localeCompare(permissionLabel(b)))
}